/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// ============================================================
// WhatsApp Floating Widget — click ripple
// ============================================================
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.whatsapp-widget');
    if (!btn) return;
    var rect = btn.getBoundingClientRect();
    var size = Math.max(rect.width, rect.height);
    var x = e.clientX - rect.left - size / 2;
    var y = e.clientY - rect.top  - size / 2;
    var ripple = document.createElement('span');
    ripple.className = 'whatsapp-click-ripple';
    ripple.style.cssText = 'width:' + size + 'px;height:' + size + 'px;left:' + x + 'px;top:' + y + 'px;';
    btn.appendChild(ripple);
    ripple.addEventListener('animationend', function () { ripple.remove(); });
  });
})();

// ============================================================
// Measurements Confirmation Checkbox
// Locks Add-to-Cart and Buy Now until the customer confirms
// their measurements are correct.
// ============================================================
(function () {
  function initMeasurementsConfirm() {
    document.querySelectorAll('[data-measurements-confirm]').forEach(function (checkbox) {
      var formId = checkbox.dataset.measurementsConfirm;
      var form = document.getElementById(formId);
      if (!form) return;

      var productFormEl = form.closest('product-form');
      if (!productFormEl) return;

      var btnObserver = null;

      function getAddBtn() { return productFormEl.querySelector('button[name="add"]'); }
      function getDynamicBtn() { return productFormEl.querySelector('dynamic-button'); }

      function lockButtons() {
        var addBtn = getAddBtn();
        if (addBtn) {
          addBtn.setAttribute('data-confirm-locked', '');
          addBtn.disabled = true;
        }
        var dBtn = getDynamicBtn();
        if (dBtn && !dBtn.querySelector('.pcis-buy-overlay')) {
          dBtn.classList.add('pcis-buy-locked');
          var overlay = document.createElement('div');
          overlay.className = 'pcis-buy-overlay';
          dBtn.appendChild(overlay);
        }

        // MutationObserver: if variant picker re-enables the add button
        // while our checkbox is still unchecked, re-lock it immediately.
        if (!btnObserver && addBtn) {
          btnObserver = new MutationObserver(function () {
            var btn = getAddBtn();
            if (btn && !checkbox.checked && !btn.disabled) {
              btn.setAttribute('data-confirm-locked', '');
              btn.disabled = true;
            }
          });
          btnObserver.observe(addBtn, { attributes: true, attributeFilter: ['disabled'] });
        }
      }

      function unlockButtons() {
        if (btnObserver) { btnObserver.disconnect(); btnObserver = null; }
        var addBtn = getAddBtn();
        if (addBtn && addBtn.hasAttribute('data-confirm-locked')) {
          addBtn.removeAttribute('data-confirm-locked');
          addBtn.disabled = false;
        }
        var dBtn = getDynamicBtn();
        if (dBtn) {
          dBtn.classList.remove('pcis-buy-locked');
          var overlay = dBtn.querySelector('.pcis-buy-overlay');
          if (overlay) overlay.remove();
        }
      }

      // Safety-net: capture-phase submit blocks any remaining edge-cases
      // (e.g. Enter key on a form field while buttons are re-rendering)
      form.addEventListener('submit', function (e) {
        if (!checkbox.checked) {
          e.preventDefault();
          e.stopImmediatePropagation();
          checkbox.focus();
          var label = document.querySelector('[for="' + checkbox.id + '"]');
          if (label) {
            label.classList.add('product-form__confirm-label--shake');
            setTimeout(function () {
              label.classList.remove('product-form__confirm-label--shake');
            }, 500);
          }
        }
      }, true);

      function updateLock() {
        if (checkbox.checked) {
          unlockButtons();
        } else {
          lockButtons();
        }
      }

      updateLock(); // apply on page load
      checkbox.addEventListener('change', updateLock);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMeasurementsConfirm);
  } else {
    initMeasurementsConfirm();
  }
})();

// ============================================================
// Product Card Image Slider
// Custom element: <product-card-image-slider class="pcis">
// ============================================================
class ProductCardImageSlider extends HTMLElement {
  connectedCallback() {
    this._track = this.querySelector('.pcis__track');
    this._slides = Array.from(this.querySelectorAll('.pcis__slide'));
    this._total = this._slides.length;
    this._current = 0;

    if (this._total < 2) return;

    // Build dots dynamically
    const dotsContainer = this.querySelector('.pcis__dots');
    this._dots = [];
    if (dotsContainer) {
      for (let i = 0; i < this._total; i++) {
        const dot = document.createElement('button');
        dot.setAttribute('type', 'button');
        dot.setAttribute('aria-label', 'Image ' + (i + 1));
        dot.className = 'pcis__dot' + (i === 0 ? ' pcis__dot--active' : '');
        dot.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this._goTo(i);
        });
        dotsContainer.appendChild(dot);
        this._dots.push(dot);
      }
    }

    // Prev / Next arrow buttons
    const prevBtn = this.querySelector('.pcis__btn--prev');
    const nextBtn = this.querySelector('.pcis__btn--next');

    if (prevBtn) {
      prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this._goTo((this._current - 1 + this._total) % this._total);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this._goTo((this._current + 1) % this._total);
      });
    }

    // Touch swipe support
    let startX = null;
    let startY = null;
    let isHorizontalSwipe = false;

    this.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      isHorizontalSwipe = false;
    }, { passive: true });

    this.addEventListener('touchmove', (e) => {
      if (startX === null) return;
      const dx = Math.abs(e.touches[0].clientX - startX);
      const dy = Math.abs(e.touches[0].clientY - startY);
      if (dx > dy && dx > 8) isHorizontalSwipe = true;
    }, { passive: true });

    this.addEventListener('touchend', (e) => {
      if (!isHorizontalSwipe || startX === null) {
        startX = null;
        return;
      }
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) {
        if (diff > 0) {
          this._goTo((this._current + 1) % this._total);
        } else {
          this._goTo((this._current - 1 + this._total) % this._total);
        }
      }
      startX = null;
      startY = null;
      isHorizontalSwipe = false;
    }, { passive: true });
  }

  _goTo(index) {
    if (this._dots.length) {
      this._dots[this._current].classList.remove('pcis__dot--active');
      this._dots[index].classList.add('pcis__dot--active');
    }
    this._current = index;
    this._track.style.transform = 'translateX(-' + (index * 100) + '%)';
  }
}

if (!customElements.get('product-card-image-slider')) {
  customElements.define('product-card-image-slider', ProductCardImageSlider);
}
